export const LOADING_GET_ADMINS = 'LOADING_GET_ADMINS';
export const RECEIVE_GET_ADMINS = 'RECEIVE_GET_ADMINS';
export const ERROR_GET_ADMINS = 'ERROR_GET_ADMINS';

export const LOADING_MODIFY_TRIAL = 'LOADING_MODIFY_TRIAL';
export const RECEIVE_MODIFY_TRIAL = 'RECEIVE_MODIFY_TRIAL';
export const ERROR_MODIFY_TRIAL = 'ERROR_MODIFY_TRIAL';